import React from "react";
export const FooterNavLink = ({ text, href, imageUrl, openInNewTab = false, }) => {
    const target = openInNewTab ? "_blank" : undefined;
    const rel = openInNewTab ? "noreferrer" : undefined;
    return (React.createElement("a", { className: "footer-nav-link", href: href, target: target, rel: rel }, imageUrl ? React.createElement("img", { src: imageUrl, alt: text }) : text));
};
